(() => {
  if (window.TMWheelCart) return;
  const RESERVATION_KEY = 'tmHesitationWheelReservation';
  const LEGACY_KEY = 'tmHesitationWheelLegacyBenefitV1';
  const PENDING_KEY = 'tmHesitationWheelPendingChoiceV1';
  const SPUN_KEY = 'tmHesitationWheelSpunAt';
  const HERITAGE_KEY = 'tmWheelHeritageHoldV1';
  const APPLIED_KEY = 'tmWheelHeritageAppliedV1';
  const HOLD_DURATION = 900000;
  const SOURCE = 'tm-private-wheel-v2';
  const WELCOME_CODE = 'WELCOME15';
  const GIFT_VARIANT_ID = 48612424089829;
  const GIFT_PROPERTY = '_tm_wheel_gift';
  const PERCENT_PRODUCT_IDS = new Set([9531976548581, 9714850791653, 9718001336549, 9777591255269, 9777591419109, 9777591615717, 9777591877861]);
  const GIFT_PRODUCT_IDS = new Set([9531976548581, 9714850791653, 9718001336549, 9761079689445, 9777591255269, 9777591419109, 9777591615717, 9777591877861]);
  const ADD_DELAYS = [250, 1400];
  const NATIVE_OFFERS = { TMPRIVATE3: ['discount', 17], TMPRIVATE5: ['discount', 18], TMPLUS5: ['discount', 20], TMMYSTERYVIBE: ['gift', 0] };
  let lastCart = null;
  let queue = Promise.resolve();
  let giftSyncPromise = null;
  let giftCheckoutPromise = null;
  let cartNavigationPromise = null;
  let cartNavigating = false;
  let giftTimer = 0;
  let subscribed = false;
  let memoryReceipt = null;
  let expiryRequest = null;
  let lastExpiryAttempt = 0;
  let expiryFailures = 0;
  const rootUrl = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const now = () => window.TMPrivateOffers?.now?.() || Date.now();
  const normalizeCode = value => String(value || '').trim().toUpperCase();
  const readValue = key => {
    try { const value = window.localStorage.getItem(key); if (value) return value; } catch {}
    if (key === APPLIED_KEY || key === HERITAGE_KEY) { try { const value = document.cookie.split('; ').find(item => item.startsWith(key + '=')); return value ? decodeURIComponent(value.slice(key.length + 1)) : null; } catch {} }
    return null;
  };
  const writeValue = (key, value) => {
    try { window.localStorage.setItem(key, value); } catch {}
    if (key === APPLIED_KEY && value.length < 3500) { try { document.cookie = key + '=' + encodeURIComponent(value) + '; Path=/; Max-Age=2592000; SameSite=Lax; Secure'; } catch {} }
  };
  const readReservation = (key = RESERVATION_KEY) => {
    try {
      const value = JSON.parse(readValue(key) || 'null');
      return value?.code && value?.title ? value : null;
    } catch { return null; }
  };
  const isNativeOffer = offer => {
    const rule = offer?.nativeShopify === true && Object.prototype.hasOwnProperty.call(NATIVE_OFFERS, offer.code) ? NATIVE_OFFERS[offer.code] : null;
    const timing = offer?.browserTimed === true
      ? Number.isFinite(offer.awardedAt) && offer.awardedAt > 0 && offer.expiresAt === offer.awardedAt + HOLD_DURATION && (offer.kind !== 'gift' || offer.permanentGift === false)
      : offer?.expiresAt === null && (offer.kind !== 'gift' || offer.permanentGift === true);
    return Boolean(rule && offer.kind === rule[0] && offer.percent === rule[1] && timing && offer.serverEnforced === false);
  };
  const legacyOffer = () => {
    const saved = readReservation();
    if (saved && saved.nativeShopify !== true && saved.serverEnforced !== true && saved.serverClaimed !== true) return { ...saved, legacy: true };
    const legacy = readReservation(LEGACY_KEY);
    if (legacy && legacy.nativeShopify !== true) return { ...legacy, legacy: true };
    try {
      const pending = JSON.parse(readValue(PENDING_KEY) || 'null');
      return pending?.prize?.code && pending.prize.nativeShopify !== true ? { ...pending.prize, legacy: true } : null;
    } catch { return null; }
  };
  const permanentGift = () => {
    const saved = readReservation();
    if (saved?.kind === 'gift' && ((isNativeOffer(saved) && saved.browserTimed !== true) || (saved.nativeShopify !== true && saved.permanentGift === true && saved.serverClaimed === true))) return saved;
    const previous = readReservation(LEGACY_KEY);
    if (previous?.kind === 'gift' && isNativeOffer(previous) && previous.browserTimed !== true) return previous;
    const legacy = legacyOffer();
    return legacy?.kind === 'gift' ? legacy : null;
  };
  const isExpired = offer => (offer?.serverEnforced === true || offer?.browserTimed === true) && offer.permanentGift !== true && Number.isFinite(offer.expiresAt) && offer.expiresAt <= now();
  const legacyNativeOffer = () => { const offer = readReservation(LEGACY_KEY); return isNativeOffer(offer) && offer.browserTimed !== true ? offer : null; };
  const getOffer = () => {
    const session = window.TMPrivateOffers?.getSession?.();
    const offer = session?.offer;
    if (window.TMPrivateOffers?.ready === true && session?.state === 'claimed'
      && (offer?.nativeShopify === true ? isNativeOffer(offer) : (offer?.serverEnforced === true || (offer?.kind === 'gift' && offer.permanentGift === true)))
      && !isExpired(offer)) return offer;
    for (const key of [HERITAGE_KEY, RESERVATION_KEY]) {
      const stored = readReservation(key);
      if (isNativeOffer(stored) && !isExpired(stored)) return stored;
    }
    return permanentGift() || legacyNativeOffer() || legacyOffer();
  };
  const rememberOffer = offer => {
    if (!offer?.code || !offer?.title) return;
    if (offer.nativeShopify === true && !isNativeOffer(offer)) return;
    const stored = readReservation();
    const previous = permanentGift() || legacyNativeOffer() || legacyOffer() || (isNativeOffer(stored) && stored.browserTimed !== true ? stored : null);
    if (previous && (normalizeCode(previous.code) !== normalizeCode(offer.code) || (offer.browserTimed === true && previous.browserTimed !== true))) writeValue(LEGACY_KEY, JSON.stringify(previous));
    const saved = { ...offer };
    if (isNativeOffer(offer)) delete saved.serverClaimed;
    else if (!offer.legacy) saved.serverClaimed = true;
    writeValue(RESERVATION_KEY, JSON.stringify(saved));
    if (!offer.legacy) {
      writeValue(SPUN_KEY, String(Date.now()));
      try { window.localStorage.removeItem(PENDING_KEY); } catch {}
    }
  };
  const applications = cart => [
    ...(cart?.cart_level_discount_applications || []),
    ...(cart?.items || []).flatMap(line => (line.line_level_discount_allocations || []).map(allocation => allocation.discount_application))
  ];
  const rejectedCode = (cart, code) => (cart?.discount_codes || []).some(item => typeof item === 'object'
    && normalizeCode(item.code) === normalizeCode(code) && item.applicable === false);
  const appliedCode = (cart, code) => {
    const target = normalizeCode(code);
    if (!target || rejectedCode(cart, target)) return false;
    return (cart?.discount_codes || []).some(item => typeof item === 'object' && normalizeCode(item.code) === target && item.applicable === true)
      || applications(cart).some(item => item?.type === 'discount_code' && normalizeCode(item.title) === target);
  };
  const protectedCodes = cart => [...new Set([
    ...(cart?.discount_codes || []).filter(item => typeof item === 'string' || item?.applicable !== false)
      .map(item => normalizeCode(typeof item === 'string' ? item : item.code)),
    ...applications(cart).filter(item => item?.type === 'discount_code').map(item => normalizeCode(item.title))
  ].filter(Boolean))];
  const cartRequest = async (path, body) => {
    const response = await fetch(rootUrl() + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.description || payload.message || 'We could not update your bag. Please try again.');
    if (Array.isArray(payload.items) && Number.isFinite(payload.total_price)) lastCart = payload;
    return payload;
  };
  const readCart = () => cartRequest('cart.js?tm_private_offer=' + Date.now());
  const updateDiscount = (discount, attributes) => cartRequest('cart/update.js', { discount, attributes });
  const queueCart = task => {
    const operation = queue.catch(() => {}).then(task);
    queue = operation.catch(() => {});
    return operation;
  };
  const notifyCart = cart => {
    if (!cart?.items) return;
    lastCart = cart;
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart, source: SOURCE } }));
    const eventName = window.PUB_SUB_EVENTS?.cartUpdate || (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : null);
    if (eventName && typeof window.publish === 'function') window.publish(eventName, { source: SOURCE, cartData: cart });
  };
  const reservationAttributes = offer => ({
    tm_private_offer_expires_at__: (offer.serverEnforced === true || offer.browserTimed === true) && offer.permanentGift !== true && Number(offer.expiresAt) > 0 ? new Date(Number(offer.expiresAt)).toISOString() : '',
    tm_private_offer_tier__: offer.title,
    tm_private_offer_kind__: offer.kind || 'discount'
  });
  const isGift = line => Number(line?.variant_id) === GIFT_VARIANT_ID && line?.properties?.[GIFT_PROPERTY] === 'Mystery Vibrator';
  const qualifies = cart => (cart?.items || []).some(line => !isGift(line) && GIFT_PRODUCT_IDS.has(Number(line.product_id)));
  const freeGift = cart => {
    const gifts = (cart?.items || []).filter(isGift);
    return gifts.length === 1 && Number(gifts[0].quantity) === 1 && Number(gifts[0].final_line_price) === 0;
  };
  const removeGiftLines = async (cart, onlyPaid = false) => {
    let line;
    while ((line = (cart?.items || []).find(item => isGift(item) && (!onlyPaid || Number(item.final_line_price) !== 0)))) {
      cart = await cartRequest('cart/change.js', { id: line.key, quantity: 0 });
    }
    return cart;
  };
  const normalizeGiftQuantity = async cart => {
    let gifts = (cart?.items || []).filter(isGift);
    while (gifts.length > 1) {
      cart = await cartRequest('cart/change.js', { id: gifts[gifts.length - 1].key, quantity: 0 });
      gifts = (cart?.items || []).filter(isGift);
    }
    if (gifts[0] && Number(gifts[0].quantity) !== 1) cart = await cartRequest('cart/change.js', { id: gifts[0].key, quantity: 1 });
    return cart;
  };
  const fingerprint = cart => JSON.stringify([cart?.total_price, cart?.discount_codes,
    (cart?.items || []).map(line => [line.key, line.quantity, line.final_line_price])]);
  const appliedReceipt = () => readReservation(APPLIED_KEY) || memoryReceipt;
  const sameHold = (left, right) => left?.code === right?.code && left?.awardedAt === right?.awardedAt && left?.expiresAt === right?.expiresAt;
  const saveReceipt = value => { memoryReceipt = value; writeValue(APPLIED_KEY, JSON.stringify(value)); };
  const recordAppliedHold = (offer, cart) => {
    if (!isNativeOffer(offer) || offer.browserTimed !== true || sameHold(appliedReceipt(), offer)) return;
    saveReceipt({ ...offer, previousCodes: protectedCodes(cart), preExistingCode: appliedCode(cart, offer.code), cleanedAt: null });
  };
  const timedAward = () => {
    for (const offer of [window.TMPrivateOffers?.getSession?.()?.offer, readReservation(HERITAGE_KEY), readReservation(), appliedReceipt()]) {
      if (isNativeOffer(offer) && offer.browserTimed === true) return offer;
    }
    return null;
  };
  const expireCart = async (cart, offer = timedAward()) => {
    if (!offer || !isExpired(offer)) return cart;
    const receipt = appliedReceipt();
    if (!sameHold(receipt, offer)) return cart;
    const permanent = permanentGift();
    if (offer.kind === 'gift') {
      let gift;
      while ((gift = (cart.items || []).find(line => isGift(line)
        && Number(line.properties?._tm_wheel_hold_awarded_at) === offer.awardedAt
        && line.properties?._tm_wheel_permanent_gift !== 'true'))) {
        cart = await cartRequest('cart/change.js', { id: gift.key, quantity: 0 });
      }
    }
    const retainGiftCode = (offer.kind === 'gift' && permanent?.permanentGift === true) || receipt.preExistingCode === true;
    const allCodes = [...new Set([...(cart.discount_codes || []).map(item => normalizeCode(typeof item === 'string' ? item : item?.code)), ...protectedCodes(cart)].filter(Boolean))];
    if (!retainGiftCode && allCodes.includes(offer.code)) {
      let remaining = protectedCodes(cart).filter(code => code !== offer.code);
      if (!remaining.length && Number(cart.item_count)) remaining = [WELCOME_CODE];
      cart = await updateDiscount(remaining.join(','), { tm_private_offer_expires_at__: '', tm_private_offer_tier__: '', tm_private_offer_kind__: '' });
    }
    const remainingTimedGift = (cart.items || []).some(line => isGift(line) && Number(line.properties?._tm_wheel_hold_awarded_at) === offer.awardedAt && line.properties?._tm_wheel_permanent_gift !== 'true');
    const submitted = (cart.discount_codes || []).map(item => normalizeCode(typeof item === 'string' ? item : item?.code));
    if ((!retainGiftCode && (submitted.includes(offer.code) || appliedCode(cart, offer.code))) || remainingTimedGift) throw new Error('Please try updating your bag again.');
    if (!receipt.cleanedAt) saveReceipt({ ...receipt, cleanedAt: now() });
    return cart;
  };
  const cleanupExpiredOffer = (options = {}) => {
    const offer = timedAward();
    if (!offer || !isExpired(offer) || !sameHold(appliedReceipt(), offer)) return Promise.resolve(lastCart);
    if (expiryRequest) return expiryRequest;
    const retryDelay = expiryFailures ? Math.min(60000, 5000 * Math.pow(2, expiryFailures - 1)) : 0;
    if (!options.force && lastExpiryAttempt && now() - lastExpiryAttempt < retryDelay) return Promise.resolve(null);
    lastExpiryAttempt = now();
    expiryRequest = queueCart(async () => {
      const cart = await readCart();
      const updated = await expireCart(cart, offer);
      expiryFailures = 0;
      if (fingerprint(cart) !== fingerprint(updated)) notifyCart(updated);
      return updated;
    }).catch(error => { expiryFailures += 1; throw error; }).finally(() => { expiryRequest = null; });
    return expiryRequest;
  };
  const applyOffer = (offer, options = {}) => queueCart(async () => {
    if (offer?.nativeShopify === true && !isNativeOffer(offer)) throw new Error('Your offer is unavailable. Please try again.');
    const syncedCart = await window.TMCartOfferReservation?.sync?.();
    let cart = options.fresh === true ? await readCart() : syncedCart?.items ? syncedCart : await readCart();
    if (!offer || isExpired(offer)) { const before = fingerprint(cart); if (offer?.browserTimed === true) cart = await expireCart(cart, offer); return { offer, cart, applied: false, reason: 'expired', changed: fingerprint(cart) !== before }; }
    if (!Number(cart.item_count)) return { offer, cart, applied: false, reason: 'empty', changed: false };
    if (offer.kind === 'discount' && (offer.serverEnforced === true || isNativeOffer(offer)) && !(cart.items || []).some(line => !isGift(line) && PERCENT_PRODUCT_IDS.has(Number(line.product_id)))) {
      return { offer, cart, applied: false, reason: 'current', changed: false };
    }
    const originalCart = cart;
    recordAppliedHold(offer, cart);
    const originalCodes = protectedCodes(cart);
    const priorApplied = originalCodes.filter(code => appliedCode(cart, code));
    const hadGift = (cart.items || []).some(isGift);
    const effective = value => offer.kind === 'gift' ? freeGift(value) : appliedCode(value, offer.code);
    const preservesCodes = value => priorApplied.every(code => appliedCode(value, code))
      && originalCodes.every(code => protectedCodes(value).includes(code));
    const safe = value => Number(value.total_price) <= Number(originalCart.total_price) && preservesCodes(value);
    const completed = async (value, applied, reason) => {
      if (isExpired(offer)) { value = await expireCart(value, offer); applied = false; reason = 'expired'; }
      return { offer, cart: value, applied, reason, changed: fingerprint(value) !== fingerprint(originalCart) };
    };
    let attemptedGiftAdd = false;
    let allowedWelcomeReplacement = false;
    const rollback = async () => {
      cart = await updateDiscount(originalCodes.join(','), originalCart.attributes || {});
      if (attemptedGiftAdd && !hadGift) cart = await removeGiftLines(cart);
      if (offer.kind === 'gift') cart = await removeGiftLines(cart, true);
      return cart;
    };
    try {
      if (offer.kind === 'gift') {
        if (!qualifies(cart)) return completed(await removeGiftLines(cart), false, 'empty-gift');
        cart = await normalizeGiftQuantity(cart);
        if (!(cart.items || []).some(isGift) && qualifies(cart)) {
          attemptedGiftAdd = true;
          await cartRequest('cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: {
            [GIFT_PROPERTY]: 'Mystery Vibrator', ...(offer.permanentGift === true ? { _tm_wheel_permanent_gift: 'true' } : {}),
            ...(offer.browserTimed === true ? { _tm_wheel_hold_awarded_at: String(offer.awardedAt), _tm_wheel_hold_expires_at: String(offer.expiresAt) } : {})
          } }] });
          cart = await readCart();
        }
        if (freeGift(cart) && safe(cart)) return completed(cart, true, 'applied');
      } else if (appliedCode(cart, offer.code)) return completed(cart, true, 'applied');
      const codes = [...new Set([...originalCodes, normalizeCode(offer.code)])];
      let candidate = await updateDiscount(codes.join(','), reservationAttributes(offer));
      if (effective(candidate) && safe(candidate)) return completed(candidate, true, 'applied');
      if (offer.kind === 'discount' && originalCodes.every(code => code === WELCOME_CODE)
        && (Number(offer.percent) || Number(String(offer.title).match(/\d+(?:\.\d+)?/)?.[0])) > 15) {
        allowedWelcomeReplacement = true;
        candidate = await updateDiscount(offer.code, reservationAttributes(offer));
        if (appliedCode(candidate, offer.code) && Number(candidate.total_price) <= Number(originalCart.total_price)) return completed(candidate, true, 'applied');
      }
      return completed(await rollback(), false, 'current');
    } catch (error) {
      try {
        cart = await readCart();
        const validReplacement = allowedWelcomeReplacement && offer.kind === 'discount'
          && originalCodes.every(code => code === WELCOME_CODE) && Number(cart.total_price) <= Number(originalCart.total_price);
        if (effective(cart) && (safe(cart) || validReplacement)) return completed(cart, true, 'applied');
        await rollback();
      } catch {}
      throw error;
    }
  });
  const giftReservation = () => {
    const current = getOffer();
    return current?.kind === 'gift' ? current : permanentGift();
  };
  const syncGift = () => {
    if (giftCheckoutPromise || cartNavigating) return Promise.resolve(lastCart);
    const offers = [getOffer(), giftReservation()].filter((offer, index, values) => offer && values.findIndex(value => value?.code === offer.code) === index);
    if (!offers.length) return Promise.resolve(null);
    if (giftSyncPromise) return giftSyncPromise;
    giftSyncPromise = (async () => {
      let cart = null;
      for (const offer of offers) {
        const outcome = await applyOffer(offer);
        if (outcome.changed) notifyCart(outcome.cart);
        cart = outcome.cart;
      }
      return cart;
    })().catch(() => null).finally(() => { giftSyncPromise = null; });
    return giftSyncPromise;
  };
  const guardGiftCheckout = () => {
    if (giftCheckoutPromise) return giftCheckoutPromise;
    giftCheckoutPromise = Promise.resolve().then(async () => {
      if (giftSyncPromise) await giftSyncPromise;
      return queueCart(async () => {
        let cart = await readCart();
        const before = fingerprint(cart);
        cart = await expireCart(cart);
        if (!qualifies(cart)) cart = await removeGiftLines(cart);
        else {
          cart = await removeGiftLines(cart, true);
          cart = await normalizeGiftQuantity(cart);
        }
        if (fingerprint(cart) !== before) notifyCart(cart);
        return (cart.items || []).filter(isGift).every(line => Number(line.final_line_price) === 0 && Number(line.quantity) === 1);
      });
    }).catch(() => false).finally(() => { giftCheckoutPromise = null; });
    return giftCheckoutPromise;
  };
  const scheduleGift = (delay = 180) => {
    window.clearTimeout(giftTimer);
    if (!cartNavigating && (getOffer() || giftReservation())) giftTimer = window.setTimeout(syncGift, delay);
  };
  const prepareCartNavigation = () => {
    if (cartNavigationPromise) return cartNavigationPromise;
    cartNavigationPromise = (async () => {
      await window.TMPrivateOffers?.ensureSession?.({ refresh: true });
      if (giftSyncPromise) await giftSyncPromise;
      const offers = [getOffer(), giftReservation()].filter((offer, index, values) => offer && values.findIndex(value => value?.code === offer.code) === index);
      let cart = null;
      for (const offer of offers) {
        const outcome = await applyOffer(offer, { fresh: true });
        if (outcome.changed) notifyCart(outcome.cart);
        cart = outcome.cart;
      }
      if (offers.some(offer => offer.kind === 'gift')) {
        if (await guardGiftCheckout() !== true) throw new Error('Gift verification failed');
        cart = lastCart;
      }
      return cart;
    })().finally(() => { cartNavigationPromise = null; });
    return cartNavigationPromise;
  };
  const bindCart = () => {
    const eventName = window.PUB_SUB_EVENTS?.cartUpdate || (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : null);
    if (subscribed || !eventName || typeof window.subscribe !== 'function') return;
    window.subscribe(eventName, event => {
      if (event?.source === SOURCE) return;
      if (event?.cartData?.items) lastCart = event.cartData;
      scheduleGift();
    });
    subscribed = true;
  };
  window.TMWheelCart = { getOffer, rememberOffer, applyOffer, readCart, notifyCart, guardGiftCheckout, cleanupExpiredOffer, prepareCartNavigation };
  window.TMPrivateOfferGiftCheckout = guardGiftCheckout;
  document.dispatchEvent(new CustomEvent('tm:wheel-cart-ready'));
  document.addEventListener('tm:private-offer-session', () => { scheduleGift(); void cleanupExpiredOffer().catch(() => {}); });
  document.addEventListener('cart:refresh', event => {
    if (event.detail?.source === SOURCE) return;
    if (event.detail?.cart?.items) lastCart = event.detail.cart;
    scheduleGift();
    const offer = timedAward();
    if (offer && isExpired(offer)) void cleanupExpiredOffer().catch(() => {});
  });
  document.addEventListener('submit', event => {
    if ((getOffer() || giftReservation()) && event.target?.matches?.('form[action*="/cart/add"]')) ADD_DELAYS.forEach(delay => window.setTimeout(syncGift, delay));
  }, true);
  document.addEventListener('click', event => {
    if (!getOffer() && !giftReservation()) return;
    const link = event.target?.closest?.('a[href]');
    if (link && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey
      && (!link.target || link.target === '_self') && !link.hasAttribute('download')) {
      let target;
      try { target = new URL(link.href, window.location.href); } catch {}
      if (target?.origin === window.location.origin && /(?:^|\/)cart\/?$/.test(target.pathname)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (cartNavigationPromise || link.getAttribute('aria-busy') === 'true') return;
        cartNavigating = true;
        window.clearTimeout(giftTimer);
        link.setAttribute('aria-busy', 'true');
        window.TMWheelVisit?.markCart?.();
        void prepareCartNavigation().catch(() => null).finally(() => {
          link.removeAttribute('aria-busy');
          window.location.assign(target.href);
        });
        return;
      }
    }
    const control = event.target?.closest?.('[data-tm-add-bundle],button[name="add"],.product-form__submit');
    if (control) ADD_DELAYS.forEach(delay => window.setTimeout(syncGift, delay));
  }, true);
  window.addEventListener('pageshow', () => { cartNavigating = false; bindCart(); scheduleGift(80); void cleanupExpiredOffer().catch(() => {}); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { scheduleGift(80); void cleanupExpiredOffer().catch(() => {}); } });
  window.addEventListener('storage', event => { if ([RESERVATION_KEY, LEGACY_KEY, PENDING_KEY, HERITAGE_KEY, APPLIED_KEY].includes(event.key)) { scheduleGift(80); void cleanupExpiredOffer().catch(() => {}); } });
  bindCart();
  [500, 1500, 3000, 6000].forEach(delay => window.setTimeout(bindCart, delay));
  document.addEventListener('DOMContentLoaded', bindCart, { once: true });
  scheduleGift(80);
  window.setInterval(() => {
    const offer = timedAward();
    if (offer && isExpired(offer) && sameHold(appliedReceipt(), offer) && !appliedReceipt()?.cleanedAt) void cleanupExpiredOffer().catch(() => {});
  }, 1000);
  void cleanupExpiredOffer().catch(() => {});
})();
